module.exports = __webpack_public_path__ + "img/v3cover-panzer.51054a01.jpg";